import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-600 to-blue-400 text-white px-4">
      <img
        src="https://via.placeholder.com/100x100.png?text=Medisys"
        alt="Logo Medisys"
        className="mb-6 rounded-full shadow-lg"
      />
      <h1 className="text-4xl font-bold mb-4 text-center">Bienvenido a Medisys</h1>
      <p className="text-lg mb-8 text-center max-w-md">
        Plataforma de gestión veterinaria moderna, modular y lista para integrarse con tu backend Laravel.
      </p>
      <Link
        to="/"
        className="bg-white text-blue-600 font-semibold px-6 py-3 rounded-md shadow hover:bg-gray-100 transition"
      >
        Iniciar sesión
      </Link>
    </div>
  );
}
